import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';

import BreadCrumb from '../../Components/Common/BreadCrumb';
import Widget from './Widget';

const Statistic = () => {
    document.title="Statistika | Sefer";

    return (
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Statistika" pageTitle="Statistika" />
                    <Row>
                        <Widget />
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
};

export default Statistic;